import { BehaviorSubject, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';
import * as i0 from "@angular/core";
var BlockUiService = (function () {
    function BlockUiService() {
        this.counter = 0;
        this._emitStatus = new BehaviorSubject({ action: 0 });
        this.emitStatus = this._emitStatus.pipe(debounce(function (status) {
            if (status.action === 1 || status.action === 2) {
                return timer(0);
            }
            else {
                return timer(200);
            }
        }));
    }
    BlockUiService.prototype.increment = function (message) {
        this.counter += 1;
        var status = null;
        if (message) {
            status = { action: 2, message: message };
        }
        else {
            status = { action: 1 };
        }
        this._emitStatus.next(status);
    };
    BlockUiService.prototype.decrement = function () {
        this.counter -= 1;
        if (this.counter < 0) {
            this.counter = 0;
        }
        if (this.counter === 0) {
            this._emitStatus.next({ action: 3 });
        }
    };
    BlockUiService.prototype.clear = function () {
        this.counter = 0;
        this._emitStatus.next({ action: 3 });
    };
    BlockUiService.prototype.network_error = function () {
        this.counter = 0;
        this._emitStatus.next({ action: 4 });
    };
    BlockUiService.ngInjectableDef = i0.defineInjectable({ factory: function BlockUiService_Factory() { return new BlockUiService(); }, token: BlockUiService, providedIn: "root" });
    return BlockUiService;
}());
export { BlockUiService };
